// 排行榜相关接口
import service from ".."

// 获取数据
export function rank (params) {
  return service({
    method: 'GET',
    url: "/rank",
    params
  })
}